//
// AUTO-GENERATED FILE. DO NOT MODIFY.
//
// This class was automatically generated by Apollo GraphQL version '4.3.3'.
//
package com.wintermar.inspection.graphql.adapter

import com.apollographql.apollo.api.Adapter
import com.apollographql.apollo.api.AnyAdapter
import com.apollographql.apollo.api.CustomScalarAdapters
import com.apollographql.apollo.api.StringAdapter
import com.apollographql.apollo.api.json.JsonReader
import com.apollographql.apollo.api.json.JsonWriter
import com.apollographql.apollo.api.missingField
import com.apollographql.apollo.api.obj
import com.wintermar.inspection.graphql.GenerateInspectionReportPdfQuery
import kotlin.Any
import kotlin.String
import kotlin.collections.List

public object GenerateInspectionReportPdfQuery_ResponseAdapter {
  public object Data : Adapter<GenerateInspectionReportPdfQuery.Data> {
    public val RESPONSE_NAMES: List<String> = listOf("generateInspectionReportPdf")

    override fun fromJson(reader: JsonReader, customScalarAdapters: CustomScalarAdapters): GenerateInspectionReportPdfQuery.Data {
      var _generateInspectionReportPdf: GenerateInspectionReportPdfQuery.GenerateInspectionReportPdf? = null

      while (true) {
        when (reader.selectName(RESPONSE_NAMES)) {
          0 -> _generateInspectionReportPdf = GenerateInspectionReportPdf.obj().fromJson(reader, customScalarAdapters)
          else -> break
        }
      }

      return GenerateInspectionReportPdfQuery.Data(
        generateInspectionReportPdf = _generateInspectionReportPdf ?: missingField(reader, "generateInspectionReportPdf")
      )
    }

    override fun toJson(
      writer: JsonWriter,
      customScalarAdapters: CustomScalarAdapters,
      `value`: GenerateInspectionReportPdfQuery.Data,
    ) {
      writer.name("generateInspectionReportPdf")
      GenerateInspectionReportPdf.obj().toJson(writer, customScalarAdapters, value.generateInspectionReportPdf)
    }
  }

  public object GenerateInspectionReportPdf : Adapter<GenerateInspectionReportPdfQuery.GenerateInspectionReportPdf> {
    public val RESPONSE_NAMES: List<String> = listOf("inspectionId", "fileName", "url")

    override fun fromJson(reader: JsonReader, customScalarAdapters: CustomScalarAdapters): GenerateInspectionReportPdfQuery.GenerateInspectionReportPdf {
      var _inspectionId: Any? = null
      var _fileName: String? = null
      var _url: String? = null

      while (true) {
        when (reader.selectName(RESPONSE_NAMES)) {
          0 -> _inspectionId = AnyAdapter.fromJson(reader, customScalarAdapters)
          1 -> _fileName = StringAdapter.fromJson(reader, customScalarAdapters)
          2 -> _url = StringAdapter.fromJson(reader, customScalarAdapters)
          else -> break
        }
      }

      return GenerateInspectionReportPdfQuery.GenerateInspectionReportPdf(
        inspectionId = _inspectionId ?: missingField(reader, "inspectionId"),
        fileName = _fileName ?: missingField(reader, "fileName"),
        url = _url ?: missingField(reader, "url")
      )
    }

    override fun toJson(
      writer: JsonWriter,
      customScalarAdapters: CustomScalarAdapters,
      `value`: GenerateInspectionReportPdfQuery.GenerateInspectionReportPdf,
    ) {
      writer.name("inspectionId")
      AnyAdapter.toJson(writer, customScalarAdapters, value.inspectionId)

      writer.name("fileName")
      StringAdapter.toJson(writer, customScalarAdapters, value.fileName)

      writer.name("url")
      StringAdapter.toJson(writer, customScalarAdapters, value.url)
    }
  }
}
